import { useState, useEffect, useRef } from "react";
import style from "./NoticeView.module.scss";
import TabList from "./TabList";
import * as YStyled from "../../../Styleds";
import { highlightLink } from "../../comm";
import apiManager from './../../../ApiManager';
import { getData } from "exif-js";
import AppConfig from './../../../AppConfig';
const NoticeView = ({ event_announcement,set_event_announcement,vo,isMaster,addModalType }) => {
    const [tab1SelectId, setTab1SelectId] = useState(0);
    const [showExpandButton, setShowExpandButton] = useState(false);
    const [expand, set_expand] = useState(false);
    const noticesRef = useRef(null);
    useEffect(() => {
    }, []);

    useEffect(() => {
        console.log("tab1SelectId",tab1SelectId)
        set_expand(false);
        const checkOverflow = () => {
            if (noticesRef.current) {
                setShowExpandButton(noticesRef.current.scrollHeight > noticesRef.current.clientHeight);
            }
        };
        setTimeout(() => {
            checkOverflow(); // Check on mount
        }, 100);
        window.addEventListener('resize', checkOverflow); // Check on resize
        return () => window.removeEventListener('resize', checkOverflow); // Cleanup
    }, [tab1SelectId,event_announcement]);
    function getData() {
        const _data = event_announcement.filter(v => v.event_announcement_category === AppConfig.announcementTags[tab1SelectId])
        console.log("_data", _data)
        if (_data.length === 0)
            return [];
        else
            return _data[0].event_announcement_message;
    }
    return (
        <>
            <YStyled.Row style={{ marginBottom: "1rem" }}>
                <YStyled.Span size={17} >重點公告</YStyled.Span>
                {isMaster &&
                    <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={400} style={{ cursor: "pointer" }} onClick={e => {
                        addModalType({
                            cls: "EditNotice", arg: {
                                eventsId: vo.events_id,
                                event_announcement: event_announcement,
                                set_event_announcement: set_event_announcement,
                                tabSelectId: tab1SelectId
                            }
                        })
                    }}>編輯</YStyled.Span>
                }
            </YStyled.Row>
            <div className={style.tab1}>
                <div className={style.menu}>
                    <TabList
                        selectId={tab1SelectId}
                        set_selectId={setTab1SelectId}
                        list={AppConfig.announcementTags}
                        ItemCls={NoticeTag}
                        clear={false}
                    />
                </div>
                <div
                    className={`${style.notices} ${expand ? style.expand : ""}`}
                    ref={noticesRef}
                >
                    <ol>
                        {getData().map((v, k) => {
                            console.log("v", v)
                            const strArr = highlightLink(v);
                            return (
                                <li key={k} style={{ marginBottom: ".6rem", fontSize: "1rem" }}>
                                    {strArr.map((obj, ind) => (
                                        obj.type === "txt" ? (
                                            <YStyled.Span key={ind} size={17} fontWeight={400}>{obj.content}</YStyled.Span>
                                        ) : (
                                            <a key={ind} href={obj.content} target="_blank" rel="noopener noreferrer">
                                                <YStyled.Span size={17} fontWeight={400}>{obj.content}</YStyled.Span>
                                            </a>
                                        )
                                    ))}
                                </li>
                            );
                        })}
                    </ol>
                    {showExpandButton &&
                        <>
                            {!expand ?
                                <YStyled.Row className={style.expandBtn} gap=".3rem" onClick={e => {
                                    set_expand(true);
                                }}>
                                    <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={600}>展開</YStyled.Span>
                                    <img src="./assets/ui/expandDown.png" />
                                </YStyled.Row >
                                :
                                <YStyled.Row className={style.expandBtn} gap=".3rem" onClick={e => {
                                    set_expand(false);
                                }}>
                                    <YStyled.Span size={13} fontFamily="SF Pro" fontWeight={600}>收合</YStyled.Span>
                                    <img src="./assets/ui/expandDown.png" />
                                </YStyled.Row >
                            }
                        </>
                    }
                </div>

            </div>
        </>
    );
};

const NoticeTag = ({ isSelect, data, index, onClick, selectId }) => {
    return (
        <div className={isSelect ? `${style.item} ${style.selected}` : style.item}>
            <div className={style.label} onClick={() => onClick(index)}>
                <YStyled.Span size={13} fontWeight={isSelect ? 700 : 400}>{data}</YStyled.Span>
            </div>
            <div className={index === selectId - 1 ? `${style.hidden}` : style.separator}></div>
        </div>
    );
};

export default NoticeView;
